import './style/ValidationFilters.css';

const ValidationFilters = ({ filters, onFiltersChange }) => {
  // Options alignées avec le backend
  const statusOptions = [
    { value: '', label: 'Tous statuts' },
    { value: 'Pending', label: 'En attente' },
    { value: 'Approved', label: 'Approuvé' },
    { value: 'Rejected', label: 'Rejeté' }
  ];

  const entityTypeOptions = [
    { value: '', label: 'Tous types' },
    { value: 'Order', label: 'Ordres' },
    { value: 'Account', label: 'Comptes' },
    { value: 'Transaction', label: 'Transactions' }
  ];

  const handleFilterChange = (key, value) => {
    onFiltersChange({
      [key]: value,
      PageNumber: 1 // Reset à la page 1 quand on change de filtre
    });
  };

  const handleClearFilters = () => {
    onFiltersChange({
      SearchTerm: '',
      EntityName: '',
      Status: '',
      PageNumber: 1
    });
  };

  const hasActiveFilters = filters.SearchTerm || filters.EntityName || filters.Status;

  return (
    <div className="validation-filters-container">
      <div className="filters-header">
        <h6 className="filters-title">
          <svg className="filters-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
          </svg>
          Filtres de recherche
        </h6>
        {hasActiveFilters && (
          <button 
            className="clear-filters-btn" 
            onClick={handleClearFilters}
            title="Réinitialiser les filtres"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
            Réinitialiser
          </button>
        )}
      </div>

      <div className="filters-grid">
        
        {/* Recherche */}
        <div className="filter-item filter-search">
          <label className="filter-label">
            <svg className="label-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            Recherche
          </label>
          <div className="search-input-wrapper">
            <svg className="search-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            <input
              type="text"
              className="filter-input search-input"
              placeholder="Référence, Demandeur..."
              value={filters.SearchTerm || ''}
              onChange={(e) => handleFilterChange('SearchTerm', e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleFilterChange('SearchTerm', e.target.value)}
            />
            {filters.SearchTerm && (
              <button 
                className="clear-input-btn"
                onClick={() => handleFilterChange('SearchTerm', '')}
                title="Effacer"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            )}
          </div>
        </div>
        {/* Filtre par Type */}
        <div className="filter-item">
          <label className="filter-label">
            <svg className="label-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
            </svg>
            Type d'entité
          </label>
          <div className="select-wrapper">
            <select
              className="filter-select"
              value={filters.EntityName || ''}
              onChange={(e) => handleFilterChange('EntityName', e.target.value)}
            >
              {entityTypeOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <svg className="select-arrow" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </div>
        </div>
        {/* Filtre par Statut */}
        <div className="filter-item">
          <label className="filter-label">
            <svg className="label-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            Statut
          </label>
          <div className="select-wrapper">
            <select
              className="filter-select"
              value={filters.Status || ''}
              onChange={(e) => handleFilterChange('Status', e.target.value)}
            >
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <svg className="select-arrow" viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 10l5 5 5-5z"/>
            </svg>
          </div>
        </div>
        
      </div>

      {/* Indicateurs de filtres actifs */}
      {hasActiveFilters && (
        <div className="active-filters">
          <span className="active-filters-label">Filtres actifs :</span>
          <div className="active-filters-tags">
            {filters.SearchTerm && (
              <span className="filter-tag">
                <span className="filter-tag-label">Recherche:</span>
                <span className="filter-tag-value">{filters.SearchTerm}</span>
                <button 
                  className="filter-tag-remove"
                  onClick={() => handleFilterChange('SearchTerm', '')}
                >
                  ×
                </button>
              </span>
            )}
            {filters.EntityName && (
              <span className="filter-tag">
                <span className="filter-tag-label">Type:</span>
                <span className="filter-tag-value">
                  {entityTypeOptions.find(opt => opt.value === filters.EntityName)?.label}
                </span>
                <button 
                  className="filter-tag-remove"
                  onClick={() => handleFilterChange('EntityName', '')}
                >
                  ×
                </button>
              </span>
            )}
            {filters.Status && (
              <span className="filter-tag">
                <span className="filter-tag-label">Statut:</span>
                <span className="filter-tag-value">
                  {statusOptions.find(opt => opt.value === filters.Status)?.label}
                </span>
                <button 
                  className="filter-tag-remove"
                  onClick={() => handleFilterChange('Status', '')}
                >
                  ×
                </button>
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ValidationFilters;